import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Flex, Link } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRoles } from "@/hooks/useRoles";

export const ConfigView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { hasReadAccess } = useRoles()

  const canUseDayMarket = hasReadAccess(PermissionCode.MARKET_CONFIG);

  const canUseRequestPolicies = hasReadAccess(PermissionCode.BUSINESS_POLICY);

  const canUseMotives = hasReadAccess(PermissionCode.MOTIVES);

  const canUseRelationFields = hasReadAccess(
    PermissionCode.FAMILY_RELATIONS_FIELDS,
  );

  const canUseFinancialMovementsDesc = hasReadAccess(
    PermissionCode.FINANCIAL_MOVEMENTS_DESC,
  );

  const canUseMaintenance = hasReadAccess(PermissionCode.APP_MAINTENANCE);

  const canUseProducts = hasReadAccess(PermissionCode.PRODUCTS);

  const canUseTrucks = hasReadAccess(PermissionCode.TRUCKS);

  const canUseDrivers = hasReadAccess(PermissionCode.DRIVERS);

  const canUseLogistic = hasReadAccess(PermissionCode.LOGISTIC);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseDayMarket && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.PRICE_BOARD)}>
          Mercado del día
        </Link>
      )}
      {canUseRequestPolicies && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.REQUEST_POLICIES)}
        >
          Políticas de negocio
        </Link>
      )}
      {canUseMotives && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.MOTIVES)}>
          Motivos
        </Link>
      )}
      {canUseProducts && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.PRODUCTS)}>
          Productos
        </Link>
      )}
       {canUseTrucks && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.TRUCKS)}>
          Camiones
        </Link>
      )}
      {
        canUseDrivers && (
            <Link variant="plain" onClick={() => navigate(AppRoutes.DRIVERS)}>
         Fleteros
        </Link>
        )
      }
      {canUseRelationFields && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.RELATION_FIELDS)}
        >
          Campos relaciones familiares
        </Link>
      )}
      {canUseFinancialMovementsDesc && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.FINANCIAL_MOVEMENTS_DESC)}
        >
          Relación comprobantes
        </Link>
      )}
      {canUseMaintenance && (
        <Link
          variant="plain"
          onClick={() => {
            if (location.pathname === AppRoutes.APP_MAINTENANCE) return;
            navigate(AppRoutes.APP_MAINTENANCE);
          }}
        >
          Mantenimiento
        </Link>
      )}
      {canUseLogistic && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.LOGISTIC)}>
          Logística completa
        </Link>
      )}
    </Flex>
  );
};
